import DefaultLogo from "./modules/authentication/pages/LoginPage/images/MatoriSnaga.png";
import OtpBankaLogo from "./modules/authentication/pages/LoginPage/images/otp-banka-logo.png";

export const LogoSrc = {
  default: DefaultLogo,
  otp: OtpBankaLogo,
};
